// TenantContext.jsx
import React, { createContext, useContext } from 'react';

const TenantContext = createContext(null);

export function useTenant() {
  return useContext(TenantContext);
}

export function TenantProvider({ children }) {
  // Subdomain aus Hostname extrahieren
  const tenantId = getTenantIdFromSubdomain();
  
  return (
    <TenantContext.Provider value={{ tenantId }}>
      {children}
    </TenantContext.Provider>
  );
}

function getTenantIdFromSubdomain() {
  const domainParts = window.location.hostname.split('.');
  if (domainParts.length > 2) {
    return domainParts[0];
  }
  return 'react-termin-app';
}
